import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Demo from "../components/Demo/Demo";
import Footer from "../components/Footer/Footer";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";

const DemoPage = () => {
  const { debug, lang } = useContext(Context);
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    if (lang === "en") {
      setText("Demo & Code");
      setText2("Full systems demo, backend access, source code");
    } else if (lang === "it") {
      setText("Demo & Code");
      setText2("Demo, accesso backend, codice sorgente");
    }
  }, [lang]);

  return (
    <>
      <title>Davide Balice - Demo & Code</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <OfficeTitle text={text} text2={text2} />
        <Demo />
        <Footer />
      </motion.main>
    </>
  );
};

export default DemoPage;
